import React from "react"
import Layout from "../components/Layout/Layout"
import Navbar from "../components/Navbar/Navbar"
import MobileNav from "../components/MobileNav/MobileNav"
import MainImage from "../components/MainImage/MainImage"
import BodyCopy from "../components/BodyCopy/BodyCopy"
import Ingredients from "../components/Ingredients/Ingredients"
import MainContent from "../components/MainContent/MainContent"
import Tag from "../components/Tag/Tag"

import { graphql } from "gatsby"
import marked from "marked"
import sanitizeHtml from "sanitize-html"

export default function Recipe({ data }) {
  const post = data.markdownRemark
  // convert ingredients markdown to HTML / sanitize HTML
  const ingredients = sanitizeHtml(marked(post.frontmatter.ingredients))
  const postSanitized = sanitizeHtml(post.html)
  return (
    <>
      <Layout>
        <Navbar />
        <MobileNav />
        <MainImage
          image={post.frontmatter.image.childImageSharp.fluid}
          title={post.frontmatter.title}
          type={post.frontmatter.postType}
        />
        <MainContent>
          <BodyCopy>
            <article
              dangerouslySetInnerHTML={{
                __html: postSanitized,
              }}
            ></article>
          </BodyCopy>
          <Ingredients>
            <article
              dangerouslySetInnerHTML={{
                __html: ingredients,
              }}
            ></article>
          </Ingredients>
        </MainContent>
      </Layout>
      <Tag>{post.frontmatter.tag}</Tag>
    </>
  )
}

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        tag
        ingredients
        postType
        image {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
